import { useEffect, useState} from 'react';


export function DynamicScriptComponent({ metaData, branding}) {
	
    const [metaScriptsAdded, setMetaScriptsAdded] = useState(false);
    const [brandingScriptsAdded, setBrandingScriptsAdded] = useState(false);

    const extractScripts = (html) => {
        if (!html) return [];
    
        const doc = new DOMParser().parseFromString(html, "text/html");
    
        return [...doc.scripts].map((script) => {
          const attributes = {};
          for (const attr of script.attributes) {
            attributes[attr.name] = attr.value;
          }
    
          return {
            attributes,
            content: script.textContent || "",
          };
        });
      };
    
 
  //position in the element
 

  const injectScripts = (scripts, target, position = "beforeend") => {
    const fragment = document.createDocumentFragment();
    const inserted = [];

    scripts.forEach(({ attributes, content }) => {
      const s = document.createElement("script");
    
      //copying attributes 
      Object.entries(attributes).forEach(([name, value]) => {
        s.setAttribute(name, value);
      });

 
      // inline script support
      if (!s.src && content) {
        s.textContent = content;
      }

      // preserve execution order
      if (!s.hasAttribute("async")) {
        s.async = false;
      }

      fragment.appendChild(s);
      inserted.push(s);
    });


    if (position === "afterbegin") {
      target.insertBefore(fragment, target.firstChild);
    } else {
      // else default beforeend 
      target.appendChild(fragment);
    }

    return inserted;
  };


    const removeScripts = (scripts) => {
        scripts.forEach((s) => s.remove());
      };
    
    useEffect(() => {

        if (!brandingScriptsAdded && branding) {

            try {

                const headHtmlScript = extractScripts(branding?.headHtml);
                const injectedHeadScript= injectScripts(headHtmlScript, document.head , "beforeend");

                const afterBodyOpenScript = extractScripts(branding?.afterBodyOpenData);
                const injectedBeforeBodyOpenScript= injectScripts(afterBodyOpenScript, document.body, "afterbegin");

                const beforeBodyCloseScript = extractScripts(branding?.beforeBodyCloseData);
                const injectedBeforeBodyCloseScript = injectScripts(beforeBodyCloseScript, document.body, "beforeend");

                setBrandingScriptsAdded(true)

                return () => {
                    removeScripts(injectedHeadScript);
                    removeScripts(injectedBeforeBodyOpenScript);
                    removeScripts(injectedBeforeBodyCloseScript);

                };

            } catch (error) {
                console.error('Error in appending the script. Please check if the call is taking place correctly', error);
            }
        }

    }, [branding]);


    useEffect(() => {
        
      if (!metaScriptsAdded && metaData) {
            try {

                const partyMetaDataScript = extractScripts(metaData?.partymetadata);
                const injectedPartyScript = injectScripts(partyMetaDataScript, document.head, "afterbegin");

                const basketMetaDataScript = extractScripts(metaData?.basketmetadata);
                const injectedBasketScript = injectScripts(basketMetaDataScript, document.head , "afterbegin");

                setMetaScriptsAdded(true)

                return () => {
                    removeScripts(injectedPartyScript);
                    removeScripts(injectedBasketScript);
                    
                };

            } catch (error) {
                console.error('Error in appending the script. Please check if the call is taking place correctly', error);
            }
        }

    }, [metaData]);

    return (
    
        <></>

    );
}